module.exports = __webpack_public_path__ + "img/max-file-content-signature-repeat.ac5cfda4.svg";